import React from 'react'
import { Doughnut } from 'react-chartjs-2';

function DoughnutChart(props) {
    let labels = []
    let values = []
    let color = [`rgba(10, 45, 68)`, `rgba(0, 185, 181)`]

    if (props.data) {
        if (Object.keys(props.data).length) {
            values = Object.values(props.data)
            labels = Object.keys(props.data)
        }
    }

    const data = {
        labels: labels,
        datasets: [
            {
                data: values,
                backgroundColor: color
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            position: 'right',
            align: 'start',
            labels: {
                usePointStyle: true,
                pointStyle: 'circle'
            }
        }
    }

    return (
        <Doughnut data={data} options={options} />
    )
}

export default React.memo(DoughnutChart)
